import EventEmitter from './EventEmitter.js'

export default class Loader extends EventEmitter
{
    constructor()
    {
        super()
        this.toLoad = 0
        this.loaded = 0
        this.items = {}
        this.loaders = [
            {
                extensions: ['mp3', 'wav'],
                action: (_resource) =>
                {
                    const audio = new Audio()
                    audio.preload = 'auto'
                    audio.addEventListener('canplaythrough', () => this.fileLoadEnd(_resource, audio), { once: true })
                    audio.addEventListener('error', () => this.fileLoadEnd(_resource, audio), { once: true })
                    audio.src = _resource.source
                    audio.load()
                }
            },
            {
                extensions: ['jpg', 'png', 'webp'],
                action: (_resource) =>
                {
                    const image = new Image()
                    image.addEventListener('load', () => this.fileLoadEnd(_resource, image))
                    image.addEventListener('error', () => this.fileLoadEnd(_resource, image))
                    image.src = _resource.source
                }
            }
        ]
    }

    load(_resources = [])
    {
        for(const resource of _resources)
        {
            this.toLoad++
            const extensionMatch = resource.source?.match(/\.([a-z0-9]+)$/i)
            const extension = extensionMatch?.[1]
            const loader = this.loaders.find((_loader) => _loader.extensions.includes(extension))
            if(loader)
                loader.action(resource)
            else
            {
                console.warn(`No loader for ${resource.source}`)
                this.toLoad--
            }
        }
    }

    fileLoadEnd(_resource, _data)
    {
        this.loaded++
        this.items[_resource.name] = _data
        this.trigger('fileEnd', [_resource, _data])
        if(this.loaded === this.toLoad)
            this.trigger('end')
    }
}
